<template>
  <div
    class="task-stage-tabs d-flex tab-header-height my-3"
    v-if="!loading || (metadata && metadata._id)"
    data-testid="tasklist__tabs-bar"
  >
    <div class="d-flex justify-space-around gap-tab all-width" data-testid="tasklist__tabs-group">
      <div
        v-for="tab in taskTabs"
        :key="tab.key"
        :class="[
          tab.tabClass,
          tab.borderClass,
          'task-tab shadow-off d-flex justify-space-between cursor-pointer width-tab padding-tab',
          { 'task-tab--selected': isTabSelected(tab.key) }
        ]"
        :aria-selected="isTabSelected(tab.key)"
        @click="$emit('select-stage', tab.key)"
        data-testid="tasklist__tab"
      >
        <div class="d-flex align-center gap-3" data-testid="tasklist__tab-label-group">
          <span class="status-empty-indicator status-indicator-width-height-10"></span>
          <p data-testid="tasklist__tab-label">{{ tab.label }}</p>
        </div>
        <p class="font-weight-bold" data-testid="tasklist__tab-count">
          {{ activeSummary[tab.summaryKey] || 0 }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import './TaskStageTabs.scss';

export default {
  name: 'TaskStageTabs',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default: () => ({}),
    },
    taskTabs: {
      type: Array,
      default: () => [],
    },
    selectedTabStage: {
      type: [Number, String],
      default: null,
    },
    activeSummary: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    isTabSelected(tabKey) {
      return Object.is(this.selectedTabStage, tabKey);
    },
  },
};
</script>
